const BreachCodes = 
 {
    "adv": {
        "mobile": "AAWEB_MRE170_a_WID",
        "web": "AAWEB_WRE170_a_WID"
    },
    "cm": {
        "mobile": "CMWEB_MRE170_a_WID",
        "web": "CMWEB_WRE170_a_WID"
    },
    "dt": {
        "mobile": "DTWEB_MRE170_a_WID",
        "web": "DTWEB_WRE170_a_WID"
    },
    "hs": {
        "mobile": "HSWEB_MRE170_a_WID",
        "web": "HSWEB_WRE170_a_WID"
    },
    "gcb": {
        "mobile": "GCWEB_MRE170_a_WID",
        "web": "GCWEB_WRE170_a_WID"
    },
    "ga": {
        "mobile": "GAWEB_MRE170_a_WID",
        "web": "GAWEB_WRE170_a_WID"
    },
    "merc": {
        "mobile": "TMWEB_MRE170_a_WID",
        "web": "TMWEB_WRE170_a_WID"
    },
    "ntn": {
        "mobile": "NTWEB_MRE170_a_WID",
        "web": "NTWEB_WRE170_a_WID"
    },
    "cp": {
        "mobile": "CPWEB_MRE170_a_WID",
        "web": "CPWEB_WRE170_a_WID"
    },
    "tb": {
        "mobile": "TBWEB_MRE170_a_WID",
        "web": "TBWEB_WRE170_a_WID"
    },
    "twc": {
        "mobile": "TCWEB_MRE170_a_WID",
        "web": "TCWEB_WRE170_a_WID"
    }
 }

export default BreachCodes


// WEBPACK FOOTER //
// ./src/components/BreachCodes.js